import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { AuthorizationCheck} from '../../../auth/authorizationCheck';
import { InstanceHistoryDetailsComponent } from './business-process-instance-history/instance-history-details/instance-history-details.component';
import { ViewInstanceReportComponent } from './business-process-instance-history/view-instance-report/view-instance-report.component';




const Reports_Routes: Routes = [
  { path: 'instanceHistoryDetails/:id',
    component: InstanceHistoryDetailsComponent, canActivate: [AuthorizationCheck], runGuardsAndResolvers: 'always'
  },
  { path: 'customInstanceView/:instanceId/:viewId',
    component: ViewInstanceReportComponent,
    canActivate: [AuthorizationCheck],
    runGuardsAndResolvers: 'always'
  }
];

export const reportsRouting: ModuleWithProviders = RouterModule.forChild(Reports_Routes) ;

